import type {
  UpcomingLawDetailResponse,
  UpcomingLawsListResponse,
} from "@/types/legislationMonitor";
import { fetchJson } from "@/lib/jsonPagination";

export async function fetchUpcomingLaws(params: {
  state: string;
  q?: string;
  page?: number;
  perPage?: number;
  signal?: AbortSignal;
}) {
  const searchParams = new URLSearchParams({ state: params.state });
  if (params.q?.trim()) searchParams.set("q", params.q.trim());
  if (params.page) searchParams.set("page", String(params.page));
  if (params.perPage) searchParams.set("per_page", String(params.perPage));

  return fetchJson<UpcomingLawsListResponse>(
    `/legislation_monitor/upcoming_laws.json?${searchParams.toString()}`,
    { signal: params.signal },
  );
}

export async function fetchUpcomingLaw(
  id: number,
  options: { municipalityId?: number; signal?: AbortSignal } = {},
) {
  const searchParams = new URLSearchParams();
  if (options.municipalityId) {
    searchParams.set("municipality_id", String(options.municipalityId));
  }

  const query = searchParams.toString();
  const path = query
    ? `/legislation_monitor/upcoming_laws/${id}.json?${query}`
    : `/legislation_monitor/upcoming_laws/${id}.json`;

  return fetchJson<UpcomingLawDetailResponse>(path, {
    signal: options.signal,
  });
}
